import { IModel, Model, ModelRecord } from './Model';

export interface IInvoiceDiscrepancyReasonModel extends IModel {
  invoiceDiscrepancyReasonId: number;
  name: string;
}

export class InvoiceDiscrepancyReasonModel
  extends Model
  implements ModelRecord<IInvoiceDiscrepancyReasonModel>
{
  invoiceDiscrepancyReasonId: number;
  name: string;

  constructor(params?: Partial<IInvoiceDiscrepancyReasonModel>) {
    super(params);

    this.invoiceDiscrepancyReasonId = _.defaultTo(
      params?.invoiceDiscrepancyReasonId,
      0,
    );
    this.name = _.defaultTo(params?.name, '');
  }
}
